import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getBaseComponentsConfig() {
    return {
        palette: {
            [PALETTE_IDS.STREAMING_INDICATOR]: {
                INDICATOR_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
            },
            [PALETTE_IDS.ODDS_BUTTON]: {
                ODDS_DISABLED_BG: COLOR.BRAND.BACKGROUND5,
                ODDS_INFO_TEXT: COLOR.BRAND.BACKGROUND1,
                ODDS_SELECTED_INFO_TEXT: COLOR.BRAND.BACKGROUND1,
                ODDS_PRICE_TEXT: {
                    fontWeight: FONT.WEIGHT_BOLD,
                    color: COLOR.BRAND.BACKGROUND1,
                },
                ODDS_SELECTED_PRICE_TEXT: {
                    fontWeight: FONT.WEIGHT_BOLD,
                    color: COLOR.BRAND.BACKGROUND1,
                },
                ODDS_UNAVAILABLE_TEXT: {
                    color: COLOR.BRAND.BACKGROUND1,
                    fontStretch: 'condensed',
                },
                ODDS_BORDER_RADIUS: 4,
                ODDS_PRICE_INDICATOR_DOWN_COLOR: COLOR.SEMANTIC.ERROR1,
                ODDS_PRICE_INDICATOR_UP_COLOR: COLOR.SEMANTIC.SUCCESS1,
            },
            [PALETTE_IDS.POPOVER]: {
                POPOVER_BG: COLOR.BRAND.BACKGROUND2,
                POPOVER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontSize: FONT.SIZE_MEDIUM,
                },
                POPOVER_CLOSE_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
            },
            [PALETTE_IDS.DROPDOWN_MENU]: {
                DROPDOWN_MENU_ITEM_TEXT: COLOR.BRAND.FOREGROUND1,
                DROPDOWN_MENU_ITEM_SELECTED_TEXT: COLOR.BRAND.FOREGROUND5,
                DROPDOWN_MENU_ITEM_BG: COLOR.BRAND.BACKGROUND1,
                DROPDOWN_MENU_ITEM_SELECTED_BG: COLOR.BRAND.ACCENT3,
            },
            [PALETTE_IDS.PRIMARY_DROPDOWN]: {
                PRIMARY_DROPDOWN_BG: COLOR.BRAND.FOREGROUND4,
                PRIMARY_DROPDOWN_TEXT: COLOR.BRAND.FOREGROUND1,
            },
            [PALETTE_IDS.SECONDARY_DROPDOWN]: {
                SECONDARY_DROPDOWN_TEXT: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.FOREGROUND5}`,
            },
            [PALETTE_IDS.TERTIARY_DROPDOWN]: {
                TERTIARY_DROPDOWN_TEXT: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.FOREGROUND5}`,
            },
            [PALETTE_IDS.BET_FUNDS_INFO]: {
                BET_FUNDS_INFO_TEXT: COLOR.BRAND.FOREGROUND2,
                BET_FUNDS_INFO_MEDIUM_TEXT: COLOR.BRAND.FOREGROUND1,
                BET_FUNDS_INFO_EMPHASIZED_TEXT: COLOR.BRAND.FOREGROUND1,
                BET_FUNDS_INFO_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
            },
            [PALETTE_IDS.PRIMARY_LINK]: {
                PRIMARY_LINK_TEXT: COLOR.BRAND.FOREGROUND1,
                PRIMARY_LINK_BG: COLOR.BRAND.BACKGROUND1,
                PRIMARY_LINK_BORDER_COLOR: COLOR.BRAND.BACKGROUND2, // #ccc
            },
            [PALETTE_IDS.SECONDARY_LINK]: {
                SECONDARY_LINK_TEXT: COLOR.BRAND.BACKGROUND6,
            },
            [PALETTE_IDS.TOGGLE_BUTTON]: {
                TOGGLE_BUTTON_TEXT: `${COLOR.BRAND.FOREGROUND1}|${COLOR.RESERVED.WHITE}`,
                TOGGLE_BUTTON_BORDER_COLOR: COLOR.BRAND.FOREGROUND3,
                TOGGLE_BUTTON_SELECTED_BG: COLOR.BRAND.ACCENT3,
                TOGGLE_BUTTON_SELECTED_TEXT: COLOR.BRAND.BACKGROUND1,
                TOGGLE_BUTTON_DISABLED_TEXT: COLOR.BRAND.BACKGROUND2,
            },
            [PALETTE_IDS.PRIMARY_BUTTON]: {
                PRIMARY_BUTTON_BG: COLOR.BRAND.CTA1,
                PRIMARY_BUTTON_TEXT: COLOR.BRAND.BACKGROUND1,
                PRIMARY_BUTTON_DISABLED_BG: COLOR.BRAND.FOREGROUND4,
                PRIMARY_BUTTON_DISABLED_TEXT: COLOR.BRAND.BACKGROUND2,
            },
            [PALETTE_IDS.SECONDARY_BUTTON]: {
                SECONDARY_BUTTON_TEXT: `${COLOR.BRAND.FOREGROUND1}|${COLOR.RESERVED.WHITE}`,
                SECONDARY_BUTTON_BORDER_COLOR: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.BACKGROUND1}`,
                SECONDARY_BUTTON_SELECTED_BG: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.BACKGROUND1}`,
                SECONDARY_BUTTON_SELECTED_TEXT: `${COLOR.BRAND.BACKGROUND1}|${COLOR.BRAND.FOREGROUND1}`,
                SECONDARY_BUTTON_DISABLED_TEXT: COLOR.BRAND.BACKGROUND2,
            },
            [PALETTE_IDS.TERTIARY_BUTTON]: {
                TERTIARY_BUTTON_TEXT: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.FOREGROUND5}`,
                TERTIARY_BUTTON_SELECTED_BG: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.BACKGROUND1}`,
                TERTIARY_BUTTON_SELECTED_TEXT: `${COLOR.BRAND.FOREGROUND5}|${COLOR.BRAND.FOREGROUND1}`,
                TERTIARY_BUTTON_DISABLED_TEXT: COLOR.BRAND.BACKGROUND2,
            },
            [PALETTE_IDS.PIVOT]: {
                PIVOT_TEXT: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.BACKGROUND1}`,
                PIVOT_INDICATOR_BG: COLOR.BRAND.ACCENT1,
            },
            [PALETTE_IDS.CLOSE_BUTTON]: {
                CLOSE_BUTTON_ICON_COLOR: `${COLOR.BRAND.FOREGROUND1}|${COLOR.RESERVED.WHITE}`,
                CIRCULAR_CLOSE_BUTTON_BG: COLOR.BRAND.BACKGROUND2,
            },
            [PALETTE_IDS.EVENT_TIMING_STATUS]: {
                EVENT_TIMING_LIVE_TEXT: COLOR.BRAND.BACKGROUND6,
                EVENT_TIMING_UPCOMING_TEXT: COLOR.BRAND.FOREGROUND2,
                EVENT_TIMING_SEPARATOR_COLOR: COLOR.BRAND.FOREGROUND3,
            },
            [PALETTE_IDS.MINI_SCOREBOARD]: {
                MINI_SCOREBOARD_SCORES_TEXT: {
                    fontFamily: FONT.FAMILY,
                    color: COLOR.BRAND.FOREGROUND1,
                },
                MINI_SCOREBOARD_SCORE_COUNT_TEXT: {
                    fontFamily: FONT.FAMILY,
                    fontWeight: FONT.WEIGHT_BOLD,
                    color: COLOR.BRAND.CTA2,
                },
                MINI_SCOREBOARD_SEGMENT_INDICATOR_TEXT: {
                    fontFamily: FONT.FAMILY,
                    color: COLOR.BRAND.FOREGROUND2,
                },
                MINI_SCOREBOARD_SERVER_INDICATOR: COLOR.BRAND.BACKGROUND6,
                MINI_SCOREBOARD_GOAL_BG: COLOR.BRAND.ACCENT2,
                MINI_SCOREBOARD_GOAL_TEXT: COLOR.BRAND.BACKGROUND1,
            },
            [PALETTE_IDS.TABLE]: {
                TABLE_HEADER_BG: COLOR.BRAND.BACKGROUND5,
                TABLE_HEADER_TEXT: COLOR.BRAND.BACKGROUND1,
                TABLE_ITEM_BG: COLOR.BRAND.BACKGROUND1,
                TABLE_ITEM_SELECTED_BG: COLOR.BRAND.BACKGROUND2,
                TABLE_ITEM_TEXT: COLOR.BRAND.FOREGROUND1,
            },
            [PALETTE_IDS.PARTICIPANTS]: {
                PARTICIPANTS_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_NORMAL,
                },
                PITCHER_TEXT: COLOR.BRAND.FOREGROUND2,
                PARTICIPANTS_SEPARATOR_COLOR: COLOR.BRAND.FOREGROUND2,
            },
            [PALETTE_IDS.BET_STATUS_ICON]: {
                OPEN_BET_ICON_COLOR: COLOR.RESERVED.ACCENT,
            },
            [PALETTE_IDS.BET_BASE_INFO]: {
                BET_STATUS_TEXT: {
                    textTransform: 'capitalize',
                    fontWeight: FONT.WEIGHT_NORMAL,
                    color: COLOR.BRAND.FOREGROUND2,
                },
                BET_MARKET_NAME_TEXT: {
                    color: COLOR.BRAND.FOREGROUND2,
                    fontWeight: FONT.WEIGHT_BOLD,
                },
                BET_BUILDER_BET_MARKET_NAME_TEXT: COLOR.BRAND.FOREGROUND2,
                BET_MULTIPLES_INFO_TEXT: COLOR.BRAND.FOREGROUND1,
            },
            [PALETTE_IDS.PROGRESS_BAR]: {
                PROGRESS_BAR_LINE_COLOR: COLOR.BRAND.BACKGROUND2,
                PROGRESS_BAR_FILL_LINE_COLOR: COLOR.BRAND.BACKGROUND6,
                PROGRESS_BAR_RANGE_LABEL_TEXT: {
                    color: COLOR.BRAND.FOREGROUND2,
                    fontSize: FONT.SIZE_XXSMALL,
                },
                PROGRESS_BAR_LIMIT_LABEL_TEXT: {
                    color: COLOR.BRAND.FOREGROUND2,
                    fontSize: FONT.SIZE_XXSMALL,
                },
            },
            [PALETTE_IDS.EARLY_PAYOUT_INDICATOR]: {
                EARLY_PAYOUT_POPOVER_BG: COLOR.BRAND.BACKGROUND2,
            },
            [PALETTE_IDS.PRICE_BOOST_LABEL]: {
                PRICE_BOOST_LABEL_ICON_CONTAINER_BG: COLOR.BRAND.ACCENT2,
                PRICE_BOOST_LABEL_ICON_COLOR: COLOR.BRAND.FOREGROUND5,
                PRICE_BOOST_LABEL_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_BOLD,
                    fontSize: 10,
                },
            },
        },
    };
}
